import React from 'react';
import {
  Button,
  InputLabel,
  TextField,
  Typography,
  withStyles,
  Grid,
  CircularProgress,
  // CssBaseline,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';

import { EVENT_CODE, EVENT_ID, EVENT_IMG, EVENTS_API_URL, LOGIN_TB, SIGNIN_URL } from '../constants';
import {
  withCookies,
  // Cookies
} from 'react-cookie';

// import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import { CustomSwal } from '../components/CustomSwal';
// import CircularProgress from '@mui/material/CircularProgress';
// import { CssBaseline } from '@mui/material';

import swal from '@sweetalert/with-react';
// import Swal from 'sweetalert2';

const moment = require('moment-timezone');
moment.tz.setDefault('Asia/Seoul');

Amplify.configure(awsconfig);

const styles = (theme) => ({
  bg: {
    // display: 'flex',
    width: '100%',
    // height: 'calc(100% - 70px)',
    height: '100vh',
    overflowY: 'auto',
    backgroundImage: `url('${EVENT_IMG}/login_bg_web.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    backgroundPosition: 'center center',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url('${EVENT_IMG}/main_bg_mob.png')`,
      backgroundSize: '100% 100%',
      height: '100%',
    },
  },

  content_grid: {
    // paddingTop: '17%',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },

  input_grid: {
    // marginLeft: '4vw',
    // justifyContent: 'flex-start',
    // [theme.breakpoints.down('sm')]: {
    //   justifyContent: 'center',
    //   padding: theme.spacing(2, 2),
    //   marginLeft: 0,
    // },
  },

  form_style: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: theme.spacing(4, 6),
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '5px',
      padding: theme.spacing(4, 4),
    },
  },
  inputLabel: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginBottom: '1vh',
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  formInput: {
    marginBottom: '10px',
    backgroundColor: '#fff',
    width: '96%',
    '& input': {
      height: '70px',
      padding: '0 1vw',
      [theme.breakpoints.down('md')]: {
        height: '40px',
        fontSize: '19px',
      },
    },

    [theme.breakpoints.down('md')]: {
      width: '100%',
      '& .MuiOutlinedInput-input': {
        padding: '10px',
      },
    },
  },
  btn: {
    boxShadow: 'none',
    // margin: '20px auto 10px',
    backgroundColor: theme.palette.third.main,
    border: '2px solid',
    borderColor: '#fff',
    borderRadius: '5px',
    color: '#fff',
    fontSize: '1.5em',
    fontWeight: 'bold',
    // padding: theme.spacing(2, 0),
    height: '70px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      color: theme.palette.third.main,
      boxShadow: 'none',
      border: '2px solid',
      borderColor: theme.palette.third.main,
    },
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1, 0, 1),
      height: '50px',
      fontSize: '1.2em',
    },
  },

  loginInfo: {
    color: '#7e7e7e',
    // fontSize: 'small',
    lineHeight: '1.5',
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      lineHeight: '1.3',
    },
  },

  logo_grid: {
    padding: theme.spacing(3, 0),
    '& img': {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 0),
      '& > div': {
        textAlign: 'center',
      },
      '& img': {
        width: '80%',
      },
    },
  },

  sponsorLogoWrap: {
    minHeight: '70px',
    backgroundColor: '#fff',
  },
  sponsorLogoDiv: {
    width: '150px',
    height: '50px',
    display: 'flex !important',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '100%',
      height: 'auto',
      marginRight: '20px',
    },
    // [theme.breakpoints.down('sm')]: {
    //   padding: theme.spacing(4, 0),
    // },
  },

  circle: {
    stroke: 'url(#linearColors)',
  },
});

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    const pathName = props.location.pathname;
    this.state = {
      username: '',
      password: '',
      email: '',
      mobile: '',
      noticeDialog: false,
      alertDialog: true,
      loading: false,
      programDialog: false,
      isSaveID: false,
      matches: window.matchMedia('(max-width:992px)').matches,
      //행사 오픈 종료일에 맞게 수정
      openDay: pathName === '/sciLogin' ? moment() : moment('2021-07-16'),
      endDay: moment('2021-07-13 23:59:59'),
      dummys: [],
      isInput: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
  }

  // getData() {
  //   let buff = new Array(8).fill(null).map((item, i) => ({
  //     id: i,
  //     img: `company${i + 1}.png`,
  //   }));
  //   this.setState({ dummys: buff }, () => {
  //     console.log(this.state.dummys);
  //   });
  // }

  componentDidMount() {
    // this.getData();
    if (this.props.cookies.get('userID')) {
      this.setState({ isSaveID: true, email: this.props.cookies.get('userID') });
    }

    fetch(`${EVENTS_API_URL}/event/info?eventId=${EVENT_ID}&code=${encodeURIComponent(EVENT_CODE)}`, {
      method: 'GET',
    })
      .then((res) => res.text())
      .then((body) => {
        let _result = JSON.parse(body);
        // console.log(_result);
        _result.Item.code = null;
        sessionStorage.setItem('Item', JSON.stringify(_result.Item));
      })
      .catch((err) => {
        console.log(err);
      });

    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').addListener(handler);
  }

  componentWillUnmount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').removeListener(handler);
  }

  handleSignIn(event) {
    if (event) event.preventDefault();
    if (!this.state.openDay.isBefore(moment())) {
      return;
    }

    const email = this.state.email.replace(/ /gi, '').toLowerCase();
    let password = this.state.email.replace(/ /gi, '').toLowerCase();
    if (email.length < 1) {
      swal('', 'Please enter your registered email', '');

      // CustomSwal('', 'Please enter your registered email', '');

      return;
    }
    if (password.length < 6) {
      password = password.padEnd(6, '0');
    }

    this.setState({ loading: true });

    Auth.signIn(EVENT_ID + '_' + email, password)
      .then((user) => {
        const idToken = user.signInUserSession.idToken;
        console.log(user);
        sessionStorage.setItem('_in_user_', user.username);
        sessionStorage.setItem('_in_jwt', idToken.getJwtToken());
        sessionStorage.setItem('_in_sub', user.attributes.sub);
        // if (idToken.payload['custom:first_name']) {
        //   sessionStorage.setItem('_in_name', idToken.payload['custom:first_name'] + ' ' + idToken.payload['custom:last_name']);
        // } else {
        //   sessionStorage.setItem('_in_name', idToken.payload['custom:in_name']);
        // }

        sessionStorage.setItem('_in_name', idToken.payload['custom:in_name']);
        sessionStorage.setItem('_in_event_id', idToken.payload['event_id']);
        sessionStorage.setItem('_in_role', idToken.payload['custom:role']);
        sessionStorage.setItem('_in_pos', idToken.payload['custom:position']);
        sessionStorage.setItem('_in_pos_en', idToken.payload['custom:position_en']);
        sessionStorage.setItem('_in_name_en', idToken.payload['custom:in_name_en']);

        let momentDate = moment();
        if (this.state.isSaveID) {
          if (!this.props.cookies.get('userID')) {
            this.props.cookies.set('userID', email, { path: '/', expires: momentDate.add(180, 'd').toDate() });
          }
        } else {
          this.props.cookies.remove('userID');
        }

        fetch(
          `${SIGNIN_URL}?username=${encodeURIComponent(idToken.payload['custom:in_name'])}&userid=${encodeURIComponent(
            user.username,
          )}&evt=${EVENT_ID}&agent=${encodeURIComponent(navigator.userAgent)}&tbName=${LOGIN_TB}&code=${encodeURIComponent(EVENT_CODE)}`,
          {
            method: 'GET',
          },
        )
          .then((data) => {
            this.setState({ loading: false });
            this.props.history.push('/main');
          })
          .catch((err) => {
            console.log(err);
            this.setState({ loading: false });
            this.props.history.push('/main');
          });
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log(err);
        swal('Unregistered email. Please check your email address', 'Registration Inquiry: onlinesympo@innon.co.kr', '');
        // CustomSwal('', 'unregistered email', '');
        // alert(err.message);
        //alert('10월 21일 오전 6시부터 입장 가능합니다.');
      });
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  openNoticeDialog = (event) => {
    this.setState({ noticeDialog: true });
  };

  closeNoticeDialog = (event) => {
    this.setState({ noticeDialog: false });
  };

  openAlertDialog = (event) => {
    this.setState({ alertDialog: true });
  };

  closeAlertDialog = (event) => {
    this.setState({ alertDialog: false });
  };
  onPrev = () => {
    this.myRef.current.onPrev();
  };
  onNext = () => {
    this.myRef.current.onNext();
  };

  changeSaveID(e) {
    this.setState({ isSaveID: e.target.checked });
  }

  // renderSponsorLogos() {
  //   const { matches, dummys } = this.state;
  //   const _settings = { dots: false, infinite: true, speed: 500, slidesToShow: matches ? 3 : 6, slidesToScroll: 1, autoplay: true };

  //   return (
  //     <Grid container justifyContent="center" className={this.props.classes.sponsorLogoWrap}>
  //       {/* 하단 스폰서 로고 */}
  //       <Grid item xs={10} md={8}>
  //         <div>
  //           <Slider {..._settings}>
  //             {dummys.map((d) => (
  //               <div key={`logo${d.id}`} className={this.props.classes.sponsorLogoDiv}>
  //                 <img src={`${COMMON_IMG}/${d.img}`} alt="" />
  //               </div>
  //             ))}
  //           </Slider>
  //         </div>
  //       </Grid>
  //     </Grid>
  //   );
  // }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.bg}>
        {/* <CssBaseline /> */}
        <Grid container justifyContent="center" className={classes.content_grid}>
          {!this.state.matches && (
            <Grid container justifyContent="flex-end" item xs={12}>
              <Grid container item xs={4} sm={4} md={3} lg={2} style={{ padding: '3vh 0', margin: '0 2vw' }}>
                <Grid container justifyContent="center" alignItems="center" item xs={6}>
                  <img src={`${EVENT_IMG}/login_logo1.png`} alt={'img'} style={{ width: '100%' }} />
                </Grid>
                <Grid container justifyContent="center" alignItems="center" item xs={6}>
                  <img src={`${EVENT_IMG}/login_logo2.png`} alt={'img'} style={{ width: '100%' }} />
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* main logo grid */}
          {this.state.matches ? (
            <Grid container justifyContent="center" style={{ paddingBottom: '4vh' }}>
              <Grid container justifyContent="flex-end" item xs={11}>
                <Grid container justifyContent="center" item xs={6} style={{ padding: '3vh 0' }}>
                  <Grid container justifyContent="center" alignItems="center" item xs={6}>
                    <Grid>
                      <img src={`${EVENT_IMG}/login_logo1.png`} alt={'img'} style={{ width: '100%' }} />
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" alignItems="center" item xs={6}>
                    <Grid>
                      <img src={`${EVENT_IMG}/login_logo2.png`} alt={'img'} style={{ width: '100%' }} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={11}>
                <img src={`${EVENT_IMG}/login_text.png`} alt={'img'} style={{ width: '100%' }} />
              </Grid>
            </Grid>
          ) : (
            <Grid container justifyContent="center" style={{ padding: '15vh 0 8vh' }}>
              <Grid item xs={12} md={8}>
                <img src={`${EVENT_IMG}/main_text.png`} alt={'img'} style={{ width: '100%' }} />
              </Grid>
            </Grid>
          )}

          {/* input grid */}
          <Grid container justifyContent="center" item xs={12} md={6} className={classes.input_grid} style={{ position: 'relative' }}>
            <Grid container justifyContent="center" item xs={11} md={12}>
              <form noValidate onSubmit={this.handleSignIn} className={classes.form_style}>
                <Grid container item xs={12}>
                  <InputLabel htmlFor="email" className={classes.inputLabel}>
                    {/* 성함  */}
                    E-mail
                  </InputLabel>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={12} md={7}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      id="email"
                      type="email"
                      name="email"
                      autoFocus
                      placeholder="Enter E-mail Address(Registred)"
                      onChange={(e) => {
                        this.setState({ isInput: true });
                        this.handleChange('email', e);
                        this.handleChange('password', e);
                      }}
                      value={this.state.email}
                      color={'primary'}
                      className={classes.formInput}
                    />

                    <Grid container justifyContent="flex-start" style={{ paddingBottom: '10px' }}>
                      <FormControlLabel
                        control={
                          <Checkbox size="small" color="primary" checked={this.state.isSaveID} onChange={(e) => this.changeSaveID(e)} />
                        }
                        label={<span style={{ color: '#aaa', fontSize: 'large' }}>Save my ID (E-mail)</span>}
                      />
                    </Grid>
                    {this.state.openDay.isBefore(moment()) ? (
                      <Typography variant="subtitle1" className={classes.loginInfo}>
                        {/* * 로그인은 사전등록에 사용한 이메일 주소를 입력해 주시기 바랍니다.
                      <br />* Please fill in your registered email address.
                      <br />
                      * 본 사이트는 Chrome에 최적화 되어있습니다. */}
                        * Please fill in your registered email address.
                        <br />* This website is optimized for Chrome.
                      </Typography>
                    ) : (
                      <Typography variant="subtitle1" className={classes.loginInfo}>
                        {/* * {{행사일}} 오픈 됩니다. */}
                      </Typography>
                    )}
                  </Grid>
                  <Grid container justifyContent="center" alignItems="flex-start" item xs={12} md={5}>
                    <Button
                      // color="primary"
                      fullWidth
                      variant="contained"
                      className={classes.btn}
                      onClick={this.handleSignIn}
                      disabled={!this.state.openDay.isBefore(moment())}
                    >
                      Join Webinar
                    </Button>

                    <Grid container justifyContent="space-evenly" item xs={12}>
                      <Grid container item xs={4} md={5}>
                        <img src={`${EVENT_IMG}/login_logo_01.png`} style={{ width: '100%' }} alt={''} />
                      </Grid>
                      <Grid container item xs={4} md={5}>
                        <img src={`${EVENT_IMG}/login_logo_02.png`} style={{ width: '100%' }} alt={''} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Grid>
        {/* sponsor logos */}
        {/* <Grid container>
          {this.state.dummys && this.state.dummys.length > 0 ? this.renderSponsorLogos() : null}
        </Grid> */}

        {/* loading progress */}
        {this.state.loading && (
          <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-15%, -50%)' }}>
            <CircularProgress size={100} thickness={4} classes={{ circle: classes.circle }} style={{ opacity: 0.75 }} />
            <svg>
              <linearGradient id="linearColors">
                <stop offset="20%" stopColor="#ecd251" />
                <stop offset="80%" stopColor="#08d8a0" />
              </linearGradient>
            </svg>
          </div>
        )}
      </div>
    );
  }
}

export default withCookies(withStyles(styles, { withTheme: true })(LoginPage));
